<ion-header>

  <ion-row class="barra-color-topo"></ion-row>

  <ion-grid class="grid-menu-topo">

    <!-- MOBILE -->

    <ion-row class="row-menu-topo ion-hide-md-up">

      <ion-menu-button class="col-menu-sanduiche ion-align-self-center">
        <ion-menu-toggle>
          <ion-img src="../../assets/icon/icone_menu_sanduiche.svg"></ion-img>
        </ion-menu-toggle>
      </ion-menu-button>

      <ion-col class="ion-align-self-center center-img">
        <ion-img class="img-logo-topo" src="../../assets/image/aceleramovel_horizontal.svg"></ion-img>
      </ion-col>

      <ion-menu-button class="col-menu-perfil ion-align-self-center" menu="end">
        <ion-menu-toggle menu="end">
          <ion-img color="primary" src="../../assets/icon/icone_perfil.svg"></ion-img>
        </ion-menu-toggle>
      </ion-menu-button>

    </ion-row>

    <!-- DESKTOP -->

    <ion-row class="row-menu-topo ion-hide-sm-down">

      <ion-col size="auto" class="col-logo-desktop ion-align-self-center">
        <ion-img class="img-logo-topo" src="../../assets/image/aceleramovel_horizontal.svg"></ion-img>
      </ion-col>

      <ion-col class="links-menu ion-align-self-center ion-text-center" style="display: contents;">
        <div *ngFor="let item of menuHeader">
          <!-- Aplique o *ngIf para ocultar o item se 'item.hidden' for true -->
          <ion-item [button]="true" lines="none" [disabled]="item.disabled" *ngIf="!item.hidden && modelLocator.menu[item.key]">
            <a (click)="touchGoToRoute(item.route)">{{item.label}}</a>
          </ion-item>
        </div>
      </ion-col>


      <ion-col size="auto" class="ion-align-self-center">
        <ion-row class="box-sair ion-align-items-center">
          <img class="img-sair-topo" src="../../assets/icon/icone_sair.svg" alt="Sair" (click)="logout()">
          <a class="txt-sair-topo" (click)="logout()">Sair</a>
        </ion-row>
      </ion-col>

    </ion-row>

  </ion-grid>

</ion-header>
